module.exports = {
    data: function() {
        return {
            search: '',
            selected: false,
            searchTimeout: false,
        }
    },
    methods: {
        doSearch(){
            this.$eventHub.$emit('doSearch', this.search);
            this.$eventHub.$emit('toggleSearch', true);
        },
        searchHit(){
            if(this.selected) {
                this.$eventHub.$emit('searchHit');
                return;
            }
            $('#topNavSearch').submit();
        },
        searchDown(){
            this.$eventHub.$emit('searchDown');
        },
        searchUp() {
            this.$eventHub.$emit('searchUp');
        },
        toggleSearch(value){
            this.$eventHub.$emit('toggleSearch', value);
        },
        onBlur(){
            this.searchTimeout = setTimeout(() => {
                this.$eventHub.$emit('toggleSearch', false);
            }, 1000);
        },
        searchClose() {
            this.search = '';
            this.$eventHub.$emit('doSearch', this.search);
            this.$eventHub.$emit('expandSearch', false);
            // this.$eventHub.$emit('searchClose');
        }
    }
};